var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "companies-teaser ci-card position-relative" },
    [
      _c("div", { staticClass: "companies-teaser-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "companies-teaser-header__text h5 d-flex mr-3 mr-md-4 p-3 p-md-4 text-primary align-items-center",
          domProps: {
            textContent: _vm._s(
              _vm.$t("ui.components.start.partner_carousel.title")
            ),
          },
        }),
      ]),
      _vm._v(" "),
      _vm.loading
        ? [_vm._m(1)]
        : [
            _setup.props.companies && _setup.props.companies.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "companies-teaser-list w-100 d-flex flex-row justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "logos overflow-hidden mx-3 mx-md-4 position-relative",
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "logosSlide1",
                              staticClass:
                                "logos-slide px-2 py-3 py-md-4 d-inline-block",
                            },
                            _vm._l(_setup.props.companies, function (company) {
                              return _c(_setup.CiCompanyTile, {
                                key: company.id,
                                attrs: {
                                  company: company,
                                  context: "start-page",
                                  "padding-class": "",
                                },
                                on: {
                                  "tracking-click": _setup.propagateTrackClick,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "logosSlide2",
                              staticClass:
                                "logos-slide px-2 py-3 py-md-4 d-inline-block",
                            },
                            _vm._l(_setup.props.companies, function (company) {
                              return _c(_setup.CiCompanyTile, {
                                key: company.id,
                                attrs: {
                                  company: company,
                                  context: "start-page",
                                  "padding-class": "",
                                },
                                on: {
                                  "tracking-click": _setup.propagateTrackClick,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : [
                  _c("div", { staticClass: "p-4 text-center text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("ui.shared.global.no_data_found"))),
                  ]),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "companies-teaser-header__icon d-none d-sm-block" },
      [_c("span", { staticClass: "mdi mdi-text-box" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loading-spinner d-flex flex-column" }, [
      _c("div", {
        staticClass:
          "d-flex justify-content-center mdi mdi-loading mdi-spin h1 my-auto",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }